module.exports = __webpack_public_path__ + "img/alinoCam.f79a2692.webp";